import NetworkBadge from './NetworkBadge'

export default NetworkBadge
